import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiSelectFilter } from '../../interfaces/multi-select-filter';

@Component({
  selector: 'app-expansion-mobile-multi-select-panel',
  templateUrl: './expansion-mobile-multi-select-panel.component.html',
  styleUrls: ['./expansion-mobile-multi-select-panel.component.scss', './expansion-mobile-multi-select-panel.component.en.scss'],
})
export class ExpansionMobileMultiSelectPanelComponent {
    @Input({ required: true }) filterItems!: MultiSelectFilter[];
    @Input() label: string = '';
    @Input() disabled: boolean = false;
    @Output() changeValue: EventEmitter<{ checked: boolean, id: string }> = new EventEmitter<{ checked: boolean, id: string }>();

    valueChange($event: any) {
        this.changeValue.emit({ checked: $event.checked, id: $event.source.value });
    }
}
